<template>
  <b-row>
    <b-col>
      <title-card title="Initial Required Documents">
        <ul>
          <li>Purchase Contract</li>
          <li>Budget</li>
        </ul>
      </title-card>
    </b-col>
    <b-col>
      <title-card title="Upload Files For This Loan">
        <upload-multiple-files
          v-if="checkPermissionToCreateLoan"
          :show-submit-button="false"
          @files-changed="pushFilesUp"
        />
      </title-card>
    </b-col>
  </b-row>
</template>

<script>
import TitleCard from '@/components/utils/TitleCard';
import UploadMultipleFiles from '@/components/utils/upload/UploadMultipleFiles';
import { LOANS_WRITE } from '@/libs/permissions_list';

export default {
  name: 'UploadSection',
  components: {
    TitleCard,
    UploadMultipleFiles,
  },
  computed: {
    checkPermissionToCreateLoan() {
      return this.$permissions.checkPermissions([LOANS_WRITE]);
    },
  },
  methods: {
    pushFilesUp(files) {
      this.$emit('files-changed', files);
    },
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/new_deal/components/upload/UploadSection.vue